import { getTenantByCookies } from '@/utils/getTenantByCookies'

import { httpClient } from '../../httpClient'

type ValidatedDataByRouteHttpResponse = {
  totalInvestment: number
  totalCostReduction: number
  totalRevenue: number
  nameRoute: string
}

type ValidatedDataByRoute = {
  totalInvestment: number
  totalCostReduction: number
  totalRevenue: number
  route: string
}

type Params = {
  date?: Date
}

type Response = {
  validatedDataByRoutes: ValidatedDataByRoute[]
}

const getDashboardValidatedDataByRoute = async ({
  date,
}: Params): Promise<Response> => {
  const tenant = await getTenantByCookies()

  if (tenant?.slug === 'trial') {
    return {
      validatedDataByRoutes: [
        {
          totalInvestment: -10,
          totalCostReduction: 20,
          totalRevenue: 30,
          route: 'Route 1',
        },
        {
          totalInvestment: -10,
          totalCostReduction: 20,
          totalRevenue: 30,
          route: 'Route 2',
        },
        {
          totalInvestment: -10,
          totalCostReduction: 20,
          totalRevenue: 30,
          route: 'Route 3',
        },
      ],
    }
  }

  const queryParmas = new URLSearchParams({
    ...(date && { date: date.toISOString() }),
  })

  const query = queryParmas.toString() ? `?${queryParmas.toString()}` : ''

  const { data } = await httpClient.get<ValidatedDataByRouteHttpResponse[]>(
    `/ideas/dashboard/validated-by-route${query}`,
  )

  const validatedDataByRoutes = data.map((validatedData) => ({
    totalInvestment: validatedData.totalInvestment
      ? Number(validatedData.totalInvestment.toFixed(2))
      : 0,
    totalCostReduction: validatedData.totalCostReduction
      ? Number(validatedData.totalCostReduction.toFixed(2))
      : 0,
    totalRevenue: validatedData.totalRevenue
      ? Number(validatedData.totalRevenue.toFixed(2))
      : 0,
    route: validatedData.nameRoute,
  }))

  return {
    validatedDataByRoutes,
  }
}

export { getDashboardValidatedDataByRoute, type ValidatedDataByRoute }
